import { UnifiedGraftModelType } from '@graftcode/protocol'

/**
 * Resolves the unified graft model type string from a node (e.g. TYPE_DEF, INSTANCE_METHOD).
 * Uses unifiedGraftModelType or legacy graftModelType; converts numeric enum to key name when needed.
 */
export const getUnifiedGraftModelType = (node: {
  unifiedGraftModelType?: unknown
  graftModelType?: unknown
}): string => {
  const value = node.unifiedGraftModelType ?? node.graftModelType
  if (typeof value === 'number') {
    return UnifiedGraftModelType[value] ?? String(value)
  }
  return typeof value === 'string' ? value : String(value)
}
